import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_PURCHASE_API
// const baseUrl = 'http://192.168.18.126:8081'

// 获取委托列表
export function fetchEntrustListApi(query) {
  return request({
    url: baseUrl + '/workbench/purchaser/page/entrust-projects',
    method: 'get',
    params: query
  })
}

// 删除委托
export function removeEntrustApi(projectId) {
  return request({
    url: baseUrl + `/workbench/purchaser/entrust-projects/${projectId}`,
    method: 'delete'
  })
}

// 发布委托
export function releaseEntrustApi(data) {
  return request({
    url: baseUrl + '/workbench/purchaser/entrust-projects/release',
    method: 'post',
    data: data
  })
}

// 发布保存后的委托
export function releaseSavedEntrustApi(data, projectId) {
  return request({
    url: baseUrl + `/workbench/purchaser/entrust-projects/${projectId}/release`,
    method: 'put',
    data: data
  })
}

// 更新委托
export function updateEntrustApi(data, projectId) {
  return request({
    url: baseUrl + `/workbench/purchaser/entrust-projects/${projectId}`,
    method: 'put',
    data: data
  })
}

// 查询委托详情
export function fetchEntrustDetailApi(projectId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/entrust-projects/${projectId}`,
    method: 'get'
  })
}

// 获取代理机构列表
export function fetchAgencyListApi(query) {
  return request({
    url: '/agency/list',
    method: 'get',
    params: query
  })
}

// 接受委托
export function acceptEntrustApi(projectId) {
  return request({
    url: baseUrl + `/workbench/purchaser/entrust-projects/${projectId}/accept`,
    method: 'post'
  })
}
// 拒绝委托
export function rejectEntrustApi(data, projectId) {
  return request({
    url: baseUrl + `/workbench/purchaser/entrust-projects/${projectId}/refuse`,
    method: 'post',
    data: data
  })
}

// 委托保存
export function saveEntrustsApi(data) {
  return request({
    url: baseUrl + '/workbench/purchaser/entrust-projects',
    method: 'post',
    data
  })
}

// 代理机构已接受委托项目分页查询
export function getAgentEntrustListApi(params) {
  return request({
    url: baseUrl + `/workbench/purchaser/search/entrust-projects`,
    method: 'get',
    params
  })
}

// 代理机构查询招标询比竞价项目数
export function getAgentEntrustProjectNumApi(projectId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/entrust-projects/${projectId}/purchase-orders/count`,
    method: 'get'
  })
}

// 根据orderId获取委托信息
export function getEntrustInfoByOrderIdApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/bidding-orders/${orderId}/entrust-project-info`,
    method: 'get'
  })
}